import Receipt from '@mui/icons-material/Receipt';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function ReceiptIcon(props: FixMe) {
  return <Receipt {...props} />;
}

export default ReceiptIcon;
